import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=64e0bcc8&scoped=true"
import script from "./personal.js?vue&type=script&lang=js&external"
export * from "./personal.js?vue&type=script&lang=js&external"
import style0 from "./personal.less?vue&type=style&index=0&id=64e0bcc8&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e0bcc8",
  null
  
)

export default component.exports